import { render } from "./Phone.vue?vue&type=template&id=1b7293e9"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"

import "./Phone.vue?vue&type=style&index=0&id=1b7293e9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__